import { Layout } from "antd";
import Router from "./components/Router";
import EmergencyModal from "./components/EmergencyModal";
import MainHeader from "./components/MainHeader";

const Main = () => (
  <Layout
    style={{
      minHeight: "100vh",
    }}
  >
    <MainHeader />
    <Layout.Content
      style={{
        overflow: "initial",
        padding: "0 12px 12px",
      }}
    >
      <Router />
    </Layout.Content>
    <Layout.Footer className="main-footer">
      <div className="box-left" />
      <div className="box-center">
        <div className="logotype">
          <img src="/logotype.png" alt="" />
        </div>
      </div>
      <div className="box-right">
        <EmergencyModal />
      </div>
    </Layout.Footer>
  </Layout>
);

export default Main;
